<template>
  <el-divider content-position="left">
    <i :class="icon" v-if="icon" />
    <span v-text="text" v-if="text" />
  </el-divider>
</template>

<script>
export default {
  name: "section-divider",
  props: {
    icon: String,
    text: String
  }
};
</script>
<style scoped lang="stylus">
i
    color #b2b2ba
    margin-right 10px
</style>
